import {none, option} from "ts-option";
import {Action, handleActions} from "redux-actions";
import {PartnerBrandState} from "./PartnerBrandState";
import {
	PARTNER_BRAND_ACCOUNTS_FETCHED,
	PARTNER_BRAND_CREATED,
	PARTNER_BRAND_FETCHED,
	PARTNER_BRAND_PAYMENTS_STATUS_FETCHED,
	PARTNER_BRAND_UPDATED,
	PARTNER_BRANDS_FETCHED,
	QUOTE_EMAIL_STYLES_FETCHED
} from "../../action/partnerBrand/actionTypes";
import Account from "../../../model/account/Account";
import {PartnerBrandSearch} from "../../../model/partnerBrand/PartnerBrand";

const initState: PartnerBrandState = {
	partnerBrandsMap: {},
	partnerBrandsSearchMap: {},
	accounts: {},
	quoteEmailStyles: none,
	pBrandPaymentsStatus: {}
};

const reducer = handleActions({
	[PARTNER_BRANDS_FETCHED]: (state: PartnerBrandState, action: Action<any>): PartnerBrandState => {
		const partnerBrandsSearchMap = action.payload.partnerBrands.reduce(
			(obj: { [key: string]: PartnerBrandSearch }, pb: PartnerBrandSearch) => {
				obj[pb.id] = pb;
				return obj
			}, {})
		return {...state, partnerBrandsSearchMap: {...state.partnerBrandsSearchMap, ...partnerBrandsSearchMap}}
	},
	[PARTNER_BRAND_FETCHED]: (state: PartnerBrandState, action: Action<PARTNER_BRAND_FETCHED>): PartnerBrandState => {
		const partnerBrandsSearchMap = {
			...state.partnerBrandsSearchMap,
			[action.payload.partnerBrand.id]: action.payload.partnerBrand.toPartnerBrandSearch()
		}
		const partnerBrandsMap = {...state.partnerBrandsMap, [action.payload.partnerBrand.id]: action.payload.partnerBrand}
		return {...state, partnerBrandsMap, partnerBrandsSearchMap}
	},
	[PARTNER_BRAND_CREATED]: (state: PartnerBrandState, action: Action<PARTNER_BRAND_CREATED>): PartnerBrandState => {
		const partnerBrandsSearchMap = {
			...state.partnerBrandsSearchMap,
			[action.payload.partnerBrand.id]: action.payload.partnerBrand.toPartnerBrandSearch()
		}
		const partnerBrandsMap = {...state.partnerBrandsMap, [action.payload.partnerBrand.id]: action.payload.partnerBrand}
		return {...state, partnerBrandsMap, partnerBrandsSearchMap}
	},
	[PARTNER_BRAND_UPDATED]: (state: PartnerBrandState, action: Action<PARTNER_BRAND_UPDATED>): PartnerBrandState => {
		const partnerBrandsSearchMap = {
			...state.partnerBrandsSearchMap,
			[action.payload.partnerBrand.id]: action.payload.partnerBrand.toPartnerBrandSearch()
		}
		const partnerBrandsMap = {...state.partnerBrandsMap, [action.payload.partnerBrand.id]: action.payload.partnerBrand}
		return {...state, partnerBrandsMap, partnerBrandsSearchMap}
	},
	[PARTNER_BRAND_ACCOUNTS_FETCHED]: (state: PartnerBrandState,
		action: Action<PARTNER_BRAND_ACCOUNTS_FETCHED>): PartnerBrandState => {
		const accounts: { [key: string]: Account[] } = {};
		Object.keys(state.accounts).forEach(key => {
			if (key != action.payload.partnerBrandId)
				accounts[key] = state.accounts[key];
		});
		accounts[action.payload.partnerBrandId] = action.payload.accounts;
		return {...state, accounts}
	},
	[QUOTE_EMAIL_STYLES_FETCHED]: (state: PartnerBrandState, action: Action<QUOTE_EMAIL_STYLES_FETCHED>): PartnerBrandState => {
		return {...state, quoteEmailStyles: option(action.payload.quoteEmailStyles)}
	},
	[PARTNER_BRAND_PAYMENTS_STATUS_FETCHED]: (state: PartnerBrandState,
		action: Action<PARTNER_BRAND_PAYMENTS_STATUS_FETCHED>): PartnerBrandState => {
		return {
			...state,
			pBrandPaymentsStatus: {...state.pBrandPaymentsStatus, [action.payload.partnerBrandId]: action.payload.paymentStatus}
		}
	},
}, initState);

export default reducer;